export default "__VITE_ASSET__BkvuoO93__"